// extracted by mini-css-extract-plugin
export default {"responseHeaderText":"FieldSelection__responseHeaderText___hGZMC","skeleton-loading":"FieldSelection__skeleton-loading___GUG34"};